import React, {ChangeEvent, Dispatch, SetStateAction, useRef} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {FormikValues} from 'formik'
import toast from 'react-hot-toast'
import {convertToBase64} from '../helperFunction/_helper'
import {MediaViewer} from './MediaViewer'

function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B` // Less than 1KB, show as Bytes

  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB` // Between 1KB and 1MB
  }

  return `${(bytes / (1024 * 1024)).toFixed(2)} MB` // 1MB or more
}

type Props = {
  formik: FormikValues
  previewUrls: string[]
  setPreviewUrls: Dispatch<SetStateAction<string[]>>
  acceptFiles: string // .png, .jpg, .jpeg, .mp4, .pdf
  max_file_size: number
}

const AttachmentMultiple = ({
  formik,
  previewUrls,
  setPreviewUrls,
  acceptFiles,
  max_file_size,
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return

    const filesArray: string[] = [...(formik.values.attachment || [])]
    const previewArray: string[] = [...previewUrls]

    const fileList = e.target.files
    if (!fileList) return

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i]
      if (file.size > max_file_size) {
        toast.error(`File size must be under ${formatBytes(max_file_size)}`)
        continue
      }

      try {
        const base64String = await convertToBase64(file)
        filesArray.push(base64String)
        previewArray.push(base64String)
      } catch (error) {
        console.error('Error converting to Base64:', error)
      }
    }

    formik.setFieldValue('attachment', filesArray)
    setPreviewUrls(previewArray)
  }

  const handleRemove = (index: number) => {
    const updatedAttachments = [...formik.values.attachment]
    const updatedPreviews = [...previewUrls]

    updatedAttachments.splice(index, 1)
    updatedPreviews.splice(index, 1)

    formik.setFieldValue('attachment', updatedAttachments)
    setPreviewUrls(updatedPreviews)
  }

  return (
    <>
      <label className='fs-4 bg-light px-6 py-2 rounded w-100' style={{cursor: 'pointer'}}>
        <KTIcon iconName='pencil' className='me-4 fs-4' />
        Add Attachement
        <input
          type='file'
          name='attachment'
          accept={acceptFiles}
          ref={fileInputRef}
          onChange={handleFileChange}
          multiple // ✅ Allow multiple file selection
          style={{visibility: 'hidden'}}
        />
      </label>

      <div className='d-flex gap-4 mt-10' style={{flexWrap: 'wrap'}}>
        {previewUrls.length > 0 &&
          previewUrls.map((url, idx) => (
            <div key={idx} className='image-input mb-8' data-kt-image-input='true'>
              <div className='image-input-wrapper w-100 h-200px'>
                <MediaViewer media={url} />
              </div>

              <span
                className='btn btn-icon btn-circle bg-dark btn-active-color-primary w-35px h-35px bg-body shadow'
                data-bs-toggle='tooltip'
                title='Remove file'
                onClick={() => handleRemove(idx)}
              >
                <KTIcon iconName='cross' className='fs-4' />
              </span>
            </div>
          ))}
      </div>
    </>
  )
}

export default AttachmentMultiple
